import ModeloDelete from './ModeloDelete'
export {ModeloDelete}
export default ModeloDelete
